import { COLOR_KEYS } from '../../../constants';
import { CompactCTASectionProps } from './CompactCTASection';

export const DEFAULT_VALUES: CompactCTASectionProps = {
  backgroundColor: COLOR_KEYS.zapier,
  ctaText: 'Sign up for free',
  ctaUrl: 'https://zapier.com/sign-up/',
  heading: 'See what automation can do for you',
  isFullWidth: true,
};
